export enum DeliveryStatus {
  Undefined = 0,
  Planned = 1,
  Released = 2,
  Active = 3,
  Finished = 4,
  Invoiced = 5,
}
